import { render, staticRenderFns } from "./NotAuthHeader.vue?vue&type=template&id=14be7bfb"
import script from "./NotAuthHeader.vue?vue&type=script&lang=ts"
export * from "./NotAuthHeader.vue?vue&type=script&lang=ts"
import style0 from "./NotAuthHeader.vue?vue&type=style&index=0&id=14be7bfb&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports